module.exports = require("./my.js");